import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { environment } from 'environments/environment';
import {AppointmentDTO} from "../model/appointment/appointmentDTO.model";

@Injectable({
    providedIn: 'root'
})
export class AppointmentService {
    private apiUrl = `${environment.API_URL}/api/appointments`;

    constructor(private http: HttpClient) {}

    getAppointments(from: string, to: string, doctorId?: number | null): Observable<AppointmentDTO[]> {
        const params: any = { from, to };
        if (doctorId) {
            params.doctorId = doctorId;
        }
        return this.http.get<AppointmentDTO[]>(this.apiUrl, { params });
    }

    createAppointment(appointment: AppointmentDTO): Observable<AppointmentDTO> {
        return this.http.post<AppointmentDTO>(this.apiUrl, appointment);
    }

    createAppointmentRequest(appointment: AppointmentDTO): Observable<AppointmentDTO> {
        return this.http.post<AppointmentDTO>(`${this.apiUrl}/request`, appointment);
    }

    updateAppointment(appointment: AppointmentDTO): Observable<AppointmentDTO>{
        return this.http.put<AppointmentDTO>(this.apiUrl, appointment);
    }

    getAppointment(publicId: string): Observable<AppointmentDTO> {
        return this.http.get<AppointmentDTO>(`${this.apiUrl}/${publicId}`);
    }

    deleteAppointment(publicId: string) {
        return this.http.delete(`${this.apiUrl}/${publicId}`);
    }
}